// extracted by mini-css-extract-plugin
export default {"root":"FeaturesDropdown__root--3Olty","title":"FeaturesDropdown__title--1vcrh","link":"FeaturesDropdown__link--2ipd7"};